import { create } from "zustand"
import { persist } from "zustand/middleware"
import localStorageNames from "data/localStorageNames"

export const useMiniappReq = create(persist((set, get) => ({
    miniappReq: null,
    miniappReqId: null,
    updateMiniappReq: (newState) => {
        set({ miniappReq: newState })
    },
    getMiniappReq: () => {
        return get().miniappReq
    },
    updateMiniappReqId: (newId) => {
        set({ miniappReqId: newId })
    },
    getMiniappReqId: () => {
        return get().miniappReqId
    }
}),
    {
        name: localStorageNames.MINIAPP_REQ
    }
))